import { v1 as uuidv1 } from 'uuid';

export const uuidV1 = () => {
    return uuidv1();
};
